import { useQuery } from '@tanstack/react-query'
import * as api from '../services/api'

export const useMeters       = () => useQuery({ queryKey: ['ra-meters'],       queryFn: api.fetchMeters })
export const useDashboard    = () => useQuery({ queryKey: ['ra-dashboard'],    queryFn: api.fetchDashboard, refetchInterval: 60_000 })
export const useCompare      = (days = 7) => useQuery({ queryKey: ['ra-compare', days], queryFn: () => api.fetchCompare(days) })

export const useTimeSeries = (meterId: string, metric: string, days = 7) =>
  useQuery({
    queryKey: ['ra-timeseries', meterId, metric, days],
    queryFn:  () => api.fetchTimeSeries(meterId, metric, days),
    enabled:  !!meterId,
  })

export const useAnomalies = (meterId: string, days = 30, z = 2.5) =>
  useQuery({
    queryKey: ['ra-anomalies', meterId, days, z],
    queryFn:  () => api.fetchAnomalies(meterId, days, z),
    enabled:  !!meterId,
  })

export const useLoadProfile = (meterId: string, days = 30) =>
  useQuery({
    queryKey: ['ra-load-profile', meterId, days],
    queryFn:  () => api.fetchLoadProfile(meterId, days),
    enabled:  !!meterId,
  })

export const useForecast = (meterId: string) =>
  useQuery({
    queryKey: ['ra-forecast', meterId],
    queryFn:  () => api.fetchForecast(meterId),
    enabled:  !!meterId,
  })

export const useVoltageQuality = (meterId: string, days = 7) =>
  useQuery({
    queryKey: ['ra-voltage', meterId, days],
    queryFn:  () => api.fetchVoltageQuality(meterId, days),
    enabled:  !!meterId,
  })

export const useFrequency = (meterId: string, days = 7) =>
  useQuery({
    queryKey: ['ra-frequency', meterId, days],
    queryFn:  () => api.fetchFrequency(meterId, days),
    enabled:  !!meterId,
  })

export const useDemandPeaks = (meterId: string, days = 30) =>
  useQuery({
    queryKey: ['ra-demand', meterId, days],
    queryFn:  () => api.fetchDemandPeaks(meterId, days),
    enabled:  !!meterId,
  })

export const useEvents = (meterId: string, days = 90) =>
  useQuery({
    queryKey: ['ra-events', meterId, days],
    queryFn:  () => api.fetchEvents(meterId, days),
    enabled:  !!meterId,
  })

export const useUptime = (meterId: string) =>
  useQuery({
    queryKey: ['ra-uptime', meterId],
    queryFn:  () => api.fetchUptime(meterId),
    enabled:  !!meterId,
  })

//  Solar hooks
export const useSolarExportImport = (meterId: string, days = 30) =>
  useQuery({ queryKey: ['ra-solar-export-import', meterId, days], queryFn: () => api.fetchSolarExportImport(meterId, days), enabled: !!meterId })

export const useSolarNetBalance = (meterId: string, days = 30) =>
  useQuery({ queryKey: ['ra-solar-net-balance', meterId, days], queryFn: () => api.fetchSolarNetBalance(meterId, days), enabled: !!meterId })

export const useSolarTimeline = (meterId: string, days = 30) =>
  useQuery({ queryKey: ['ra-solar-timeline', meterId, days], queryFn: () => api.fetchSolarTimeline(meterId, days), enabled: !!meterId })

export const useSolarSelfSufficiency = (meterId: string, days = 30) =>
  useQuery({ queryKey: ['ra-solar-self-sufficiency', meterId, days], queryFn: () => api.fetchSolarSelfSufficiency(meterId, days), enabled: !!meterId })
